import $http from '@/libs/axios'

class ReturnOrdersAPI {
  static async getSettings(branchId: number) {
    return (await $http.get(`/return-orders/settings/${branchId}`)).data
  }
}

export default ReturnOrdersAPI
